// LES CONTRÔLEURS QUE LES DEUX CÔTÉS EMPLOIENT.
//
// Ce fichier existe pour qu'aucun d'eux ne soit déclaré deux fois : le site public et le
// back-office chargent chacun leur paquet, et un contrôleur recopié dans les deux finirait par
// diverger — le symptôme serait un comportement différent selon l'écran, sans rien pour le dire.
//
// `confirm-box` en fait partie parce que les TROIS gabarits rendent ConfirmBoxComponent : celui du
// site public, celui du back-office, et celui de l'authentification.

import { application } from "./application"

import ConfirmBoxController from "./confirm_box_controller"
application.register("confirm-box", ConfirmBoxController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import FilterFormController from "./filter_form_controller"
application.register("filter-form", FilterFormController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)
